<template>
  <div class="component-invoice-card">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <small>R$</small>
        <span class="value">
          {{ value }}
        </span>
      </div>
      <i class="fs-20 fa" :class="icon" />
    </div>
    <small>Quantidade: {{ amount }}</small>
    <div class="mt-6">
      {{ name }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    amount: [String, Number],
    value: String,
    name: String,
    icon: String
  }
};
</script>
<style lang="scss" scoped>
.component-invoice-card {
  height: 100%;
  padding: 20px;
  border-radius: 8px;
  color: #77788edd;
  border: 1px solid #d2d4df;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);

  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/waves/waves-primary-90deg.svg");

  .value {
    font-size: 22px;
    line-height: 40px;
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
  }
}
</style>
